// Canonical measurement-unit values must match the backend's `convert_to_unit`
// unit_mapping (store_management/utils/units.py), which recognizes the
// American spelling "centimeters" (case-insensitive) — not "centimetres".
export const MEASUREMENT_UNITS = [
    { value: 'Grams', label: 'Grams' },
    { value: 'Kilograms', label: 'Kilograms' },
    { value: 'Milliliters', label: 'Milliliters' },
    { value: 'Liters', label: 'Liters' },
    { value: 'Centimeters', label: 'Centimeters' },
    { value: 'Meters', label: 'Meters' },
    { value: 'Pieces', label: 'Pieces' },
];

export const DEFAULT_MEASUREMENT_UNIT = 'Grams';
